// Single source of truth for Special Machines.
// Add new entries here and they will automatically appear on:
//  - /solutions (Special Machines grid)
//  - Home page Featured Projects carousel
export type SpecialMachine = {
  en: string;
  sl: string;
  image: string;
  href: string;
};

export const specialMachines: SpecialMachine[] = [
  {
    en: "Industrial Pedestal Welders",
    sl: "Industrijski stacionarni varilni stroji",
    image: "/products/pedestal-a135.webp",
    href: "/products/industrial-pedestal-welders",
  },
  {
    en: "Industrial Projection Welders",
    sl: "Industrijski stroji za bradavičasto varjenje",
    image: "/products/projection-a129.webp",
    href: "/products/industrial-projection-welders",
  },
  {
    en: "Industrial Seam Welders",
    sl: "Industrijski stroji za kolutno varjenje",
    image: "/products/seam-a139.webp",
    href: "/products/industrial-seam-welders",
  },
  {
    en: "Multi Spot Welding Machine",
    sl: "Večtočkovni varilni stroj",
    image: "/products/multispot-5.webp",
    href: "/products/multi-spot-welding-machine",
  },
  {
    en: "Robotic Spot Welding Guns",
    sl: "Robotske točkovne varilne pištole",
    image: "/solutions/rrwg-2001.webp",
    href: "/solutions/robotic-spot-welding-guns",
  },
  {
    en: "Lock Welding",
    sl: "Varjenje ključavnic",
    image: "/solutions/lock-welding-stublina.png",
    href: "/solutions/lock-welding",
  },
  {
    en: "Tension Ring Welding",
    sl: "Varjenje zateznih obročev",
    image: "/solutions/tension-ring-welding-machine.webp",
    href: "/solutions/tension-ring-welding",
  },
  {
    en: "Welding machine for barrel handles",
    sl: "Stroj za varjenje ročic na sode",
    image: "/solutions/barrel-handle-welding-machine.png",
    href: "/solutions/barrel-handle-welding",
  },
  {
    en: "Welding machine for tapping barrels",
    sl: "Stroj za varjenje natočnih sodov",
    image: "/solutions/tapping-barrel-welding-machine.png",
    href: "/solutions/tapping-barrel-welding",
  },
  {
    en: "Welding machine for protective mesh",
    sl: "Stroj za varjenje zaščitnih mrež",
    image: "/solutions/protective-mesh-welding-machine.png",
    href: "/solutions/protective-mesh-welding",
  },
];
